import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import template from '../../templates/FeatureCreator/FeatureCreatorCard.rt';
import {getActiveFeatureImageStyle, selectItemUpdates} from '../../selectors';
import * as actions from '../../actions';
import _ from 'lodash';
import {AccessRights} from './../../schemas/accessRightsModel';
import * as Misc from '../../misc';
import * as NFActions from './NewFeature/NewFeatureActions';
import * as PSActions from './../ProjectScope/ProjectScopeActions';
import {
  getAssociatedFeaturesByNakedNameFromState,
  hasSubFor
} from './../ProjectScope/ProjectScopeSelector';

function mapStateToProps(state, props) {
  const {feature} = props;
  const AR = AccessRights.get(state);
  const canEdit = AR.isSiteAdmin(false) || AR.isFabMaster() || AR.isFabAdmin();
  const canDelete = AR.isSiteAdmin(true);

  let cleanFeature = {...feature};
  let featureUpdates = selectItemUpdates(state, {id: cleanFeature.id});

  cleanFeature.fabricatorData = _.assign({}, cleanFeature.fabricatorData, featureUpdates);
  let featureList = [{text: "Material", value: "-1"}, ...props.activeFeatureList];

  let associatedFeatures = null;
  if (cleanFeature.complex) {
    associatedFeatures = getAssociatedFeaturesByNakedNameFromState(state, cleanFeature.nakedName).map(f => f.id)
  }

  let groupedFeaturesByName = null;
  if (_.size(cleanFeature.groupedFeaturesByName) > 1) {
    groupedFeaturesByName = _.values(cleanFeature.groupedFeaturesByName).map(f => f.id);
  }

  return {
    imageStyle: getActiveFeatureImageStyle(state),
    updatedFeature: cleanFeature,
    feature: {...feature},
    featureList: featureList,
    AR,
    canEdit,
    canDelete,
    hasSubFor: hasSubFor(state),
    associatedFeatures,
    groupedFeaturesByName
  };
}

function mapDispatchToProps(dispatch, ownProps) {
  return {
    updateTransientField: (key, value, addValueData) => dispatch(actions.updateTransientField(ownProps.feature, key, value, addValueData)),
    showEditOverlay: (feature) => dispatch(NFActions.showNewFeatureOverlay(ownProps.groupName, true, feature)),
    deleteFeature: (feature) => dispatch(PSActions.deleteFeature(feature))
  };
}

class featureCreatorCard extends PureComponent {
  constructor(props) {
    super(props);
    this._setStateFromProps(props, true);
  }
  _setStateFromProps = (props, init = false) => {
    const uf = props.updatedFeature;
    let hideFromKitchenVisualizer = true,
        hideFromFrontEnd = true,
        hideFromBathroomVisualizer = true,
        processedName = /(.*)(\[.*\])/gi.exec(uf.name),
        displayName = _.trim(uf.originalNakedName).length > 0 ? _.trim(uf.originalNakedName) : ((processedName && processedName[1]) || uf.name),
        unit = uf.unit,
        price = uf.cost,
        description = uf.description,
        fabData = uf.fabricatorData,
        complexLogic = null,
        enabled = false,
        editingDescription = false,
        displayLogic = null,
        fabFeatId = 0,
        unlocked = false,
        hasLayers = {kv3: uf.hasLayers && uf.hasLayers.kv3, brv: uf.hasLayers && uf.hasLayers.brv, kv4: uf.hasLayers && uf.hasLayers.kv4},
        bvMeta = (processedName && processedName[2]) || "",
        metaData = uf.metaData;

    if (typeof fabData.hideFromKitchenVisualizer !== 'undefined') {
      hideFromKitchenVisualizer = fabData.hideFromKitchenVisualizer;
    }

    if (typeof fabData.hideFromFrontEnd !== 'undefined') {
      hideFromFrontEnd = fabData.hideFromFrontEnd;
    }

    if(this && this.state) {
      editingDescription = this.state.editing.description;
    }

    if(fabData) {
      if(fabData.displayName && fabData.displayName.length > 0) {
        displayName = fabData.displayName;
        var processedFabDataName = /(.*)(\[.*\]?)/gi.exec(fabData.displayName);
        if(processedFabDataName) {
          bvMeta = processedFabDataName[2] || bvMeta;
          displayName = processedFabDataName[1] || displayName;
        }
      }
      if(fabData.unit && _.trim(fabData.unit).length > 0) unit = fabData.unit;
      if(fabData.price !== null) price = fabData.cost;
      if(fabData.description && _.trim(fabData.description).length > 0) description = fabData.description;
      if(fabData.complexLogic && _.trim(fabData.complexLogic).length > 0) complexLogic = fabData.complexLogic;
      if(fabData.displayLogic) displayLogic = fabData.displayLogic;
      if(fabData.unlocked) unlocked = fabData.unlocked;
      if(!fabData.hideFromBathroomVisualizer) hideFromBathroomVisualizer = fabData.hideFromBathroomVisualizer;
      if(fabData.metaData) metaData = fabData.metaData;
      fabFeatId = fabData.id;
      enabled = fabData.enabled;
    }


    let newState = {
      editing: {
        description: editingDescription
      },
      pendingRule: {
        entityId: 0,
        comparison: "<",
        value: 0
      },
      displayLogic: {...displayLogic},
      enabled,
      hideFromKitchenVisualizer,
      hideFromBathroomVisualizer,
      hideFromFrontEnd,
      displayName,
      description,
      complexLogic,
      bvMeta,
      metaData,
      unit: _.trim(unit),
      cost: price,
      layers: hasLayers,
      AR: props.AR,
      showDLDDL: false,
      fabFeatId,
      unlocked,
      allowUpdate: false
    };

    if(init) {
      this.state = newState;
    } else {
      this.setState(newState);
    }
  }

  handleChangeField = (field, value) => {
    return new Promise((resolve) => {
      this.setState({[field]: value}, resolve);
    }).catch(console.error);
  }

  handleChangeAndUpdateField = (field, value) => {
    return this.handleChangeField(field, value)
      .then(() => this.updateField(field, value));
  }

  updateField = (key, value) => {
    this.props.updateTransientField(key, value, {
      associatedFeatures: this.props.associatedFeatures,
      groupedFeaturesByName: this.props.groupedFeaturesByName
    });
  }
  onChangeEnabled = (value) => {
    this.handleChangeAndUpdateField('enabled', value);
  }

  toggleLock = () => {
    const newVal = !this.state.unlocked;
    this.handleChangeField('unlocked', newVal).then(() => this.updateField('unlocked', newVal));
  }

  isVisible = (type) => {
    switch(type) {
      case 'bv':
        if ( window.location.hostname.toLowerCase().includes('granitefabricatorsdirect.com')
          || window.location.hostname.toLowerCase().includes('quotecountertops.com')
          || window.location.hostname.toLowerCase().includes('quotegranite.com')
        ) {
          return false;
        }
        break;
    }
    return true;
  }

  onChangePrice = (ev) => {
    const price = ev.target.value.replace(/[^0-9\.]/gi, '');
    if(price.toString().length <= 10) {
      this.handleChangeAndUpdateField('cost', price);
    }
  }
  displayNameTimer = null;
  onChangeDisplayName = (ev) => {
    if(this.displayNameTimer)
      window.clearTimeout(this.displayNameTimer);
    let newDisplayName = "";
    if(_.trim(ev.target.value).length > 0) {
      newDisplayName = this.props.groupName + ' - ' + ev.target.value;
    }
    if(newDisplayName.length > 255) {
      newDisplayName = newDisplayName.substring(0, 255);
    }
    this.handleChangeField('displayName', newDisplayName).then(() => {
      let processedName = /(.*)(\[.*\])/gi.exec(this.props.updatedFeature.name),
          displayName = (processedName && processedName[1]) || this.props.updatedFeature.name;

      let toServerDisplayName = _.trim(newDisplayName).length > 0 ? newDisplayName + this.state.bvMeta : displayName + this.state.bvMeta;
      this.displayNameTimer = window.setTimeout(() => this.updateField('displayName', toServerDisplayName), 500)
    });
  }
  onChangeUnit = (unit) => {
    this.handleChangeAndUpdateField('unit', unit);
  }
  onChangeDescription = () => {
    this.handleChangeAndUpdateField('description', this.state.description);
    this.handleChangeAndUpdateField('complexLogic', this.state.complexLogic);
    this.handleChangeAndUpdateField('displayLogic', this.state.displayLogic);
  }
  cleanDisplayName = (name) => {
    return _.trim(name.replace(this.props.groupName + " - ", ""));
  }

  handleDisplayLogicCheck = () => {
    let newDisplayLogic = this.state.displayLogic;
    if(_.isEmpty(newDisplayLogic)) {
      newDisplayLogic = {
        action: "show",
        displayRules: [],
        entity: "FabricatorFeature",
        entityId: this.state.fabFeatId,
        id: 0,
        enabled: true
      }
    } else {
      newDisplayLogic.enabled = !newDisplayLogic.enabled;
    }
    this.setState({displayLogic: newDisplayLogic}, this.forceUpdate);
  }

  updateDisplayLogic = (field, value) => {
    let displayLogic = this.state.displayLogic;
    displayLogic[field] = value;
    this.setState({displayLogic}, this.forceUpdate);
  }

  updateDisplayRule = (rule, field, value) => {
    let displayLogic = this.state.displayLogic;
    let displayRules = displayLogic.displayRules;
    let index = displayRules.indexOf(rule);
    if(index >= 0) {
      displayRules[index][field] = value;
      this.updateDisplayLogic('displayRules', displayRules);
    } else {
      console.error("rule not found: ", rule, displayRules);
    }
  }

  updatePendingRule = (field, value) => {
    var pendingRule = this.state.pendingRule;
    pendingRule[field] = value;
    this.setState({pendingRule}, this.forceUpdate);
  }

  addDisplayRule = () => {
    var displayRules = this.state.displayLogic.displayRules || [];
    displayRules.push({
      id: 0,
      entityId: this.state.pendingRule.entityId,
      entity: "FabricatorFeature",
      comparison: this.state.pendingRule.comparison,
      value: this.state.pendingRule.value
    });
    this.updateDisplayLogic('displayRules', displayRules);
  }

  deleteDisplayRule = (rule) => {
    let displayLogic = this.state.displayLogic;
    let displayRules = displayLogic.displayRules;
    let index = displayRules.indexOf(rule);
    if(index >= 0) {
      displayRules.splice(index, 1);
      this.updateDisplayLogic('displayRules', displayRules);
    } else {
      console.error("rule not found: ", rule, displayRules);
    }
  }

  getUnitOptions = () => {
    const {feature} = this.props;
    const allUnits = feature.unitOptions;
    return allUnits.concat('No Quantity').map(value => ({
      value: _.trim(value),
      text: value,
      static: true
    }));
  }

  toggleVisibility = (e, val, forcedValue) => {
    Misc.ignoreDefault(e);
    if(this.props.canEdit) {
      let field = 'hideFromFrontEnd';
      switch(val) {
        case "KV":
          field = 'hideFromKitchenVisualizer';
          break;
        case "BV":
          field = 'hideFromBathroomVisualizer';
          break;
      }

      let newValue = !this.state[field];
      if (forcedValue !== undefined)
      {
        if (forcedValue === this.state[field])
          return ; // no change, is same value
        newValue = forcedValue;
      }

      let complete = () => {
        this.handleChangeAndUpdateField(field, newValue).then(() => {
          if(this.state.hideFromFrontEnd && (this.state.hideFromKitchenVisualizer || !this.state.layers.kv3) && this.state.hideFromBathroomVisualizer ) {
            this.onChangeEnabled(false);
          } else {
            this.onChangeEnabled(true);
          }
        });
      }

      if(!this.props.hasSubFor('kitchen') && (!this.state.hideFromFrontEnd || !this.state.hideFromKitchenVisualizer)) {
        this.setState({hideFromFrontEnd: true, hideFromKitchenVisualizer: true}, () => {
          this.handleChangeAndUpdateField('hideFromFrontEnd', true)
            .then(() => this.handleChangeAndUpdateField('hideFromKitchenVisualizer', true))
            .then(complete);
        });
      }
      else if(!this.props.hasSubFor('bathroom') && (!this.state.hideFromBathroomVisualizer)) {
        this.setState({hideFromBathroomVisualizer: true}, () => {
          this.handleChangeAndUpdateField('hideFromBathroomVisualizer', true)
          .then(complete);
        });
      }
      else {
        complete();
      }
    }
  }

  handleVisibilityClick = (e, val) => {
    Misc.ignoreDefault(e);
    if(this.props.canEdit) {
      if(e.metaKey || e.ctrlKey) {
        this.toggleVisibility(e, val);
      } else {
        this.setState({showingVisibility: !this.state.showingVisibility});
      }
    }
  }

  handleDelete = (feature) => {
    if(this.props.canDelete) {
      this.props.deleteFeature(feature);
    }
  }

  update = () => this.forceUpdate;
  setAllowUpdate = () => this.setState({allowUpdate: true});

  componentDidMount() {
    const {dispatcher} = this.props;
    if (dispatcher)
      dispatcher.addListener(this.dispatcherMethod);

    document.addEventListener('save-new-feature', this.update);
    document.addEventListener('transientUpdatesCleared', this.setAllowUpdate);
    document.addEventListener("post-load-project-scope-data", this.setAllowUpdate);
  }

  dispatcherMethod = (command, parameters) => {
    if (command === 'enable_bv_qt') {
      this.toggleVisibility({}, 'QT', false);
      this.toggleVisibility({}, 'BV', false);
      this.toggleVisibility({}, 'KV', false);
    } else if (command === 'disable_bv_qt') {
      this.toggleVisibility({}, 'QT', true);
      this.toggleVisibility({}, 'BV', true);
      this.toggleVisibility({}, 'KV', true);
    }
  }

  componentWillUnmount() {
    document.removeEventListener('save-new-feature', this.update);
    document.removeEventListener('transientUpdatesCleared', this.setAllowUpdate);
    document.removeEventListener("post-load-project-scope-data", this.setAllowUpdate);
    if (this.props.dispatcher)
      this.props.dispatcher.removeListener(this.dispatcherMethod);
  }

  updateTimer = null;
  componentWillReceiveProps = (nextProps) => {
    if(this.state.allowUpdate) {
      if(this.updateTimer)
        window.clearTimeout(this.updateTimer);
      this.updateTimer = window.setTimeout(() => this._setStateFromProps(nextProps), 100);
    }
  }

  onBlurDisplayName = () => {
    if(_.trim(this.state.displayName).length === 0) {
      this.setState({displayName: this.props.updatedFeature.name});
    }
  }

  render = template
}

featureCreatorCard.propTypes = {
  feature: PropTypes.object.isRequired,
  updatedFeature: PropTypes.object.isRequired,
  updateTransientField: PropTypes.func.isRequired,
  dispatcher: PropTypes.object
};

const FeatureCreatorCard = connect(mapStateToProps, mapDispatchToProps)(featureCreatorCard);

export {FeatureCreatorCard};
